import config from '@/config';
import { policies } from '@/core/agreements';

const { mainSiteUrl, helpCenterUrl } = config;

function FooterLink({ href, children }: { href: string; children: React.ReactNode }) {
  return (
    <a
      href={href}
      target="_blank"
      rel="noreferrer"
      className="text-12 text-on-surface-muted transition-colors hover:text-on-surface"
    >
      {children}
    </a>
  );
}

export default function Footer({
  style,
  is404 = false,
}: {
  style?: React.CSSProperties;
  is404?: boolean;
}) {
  const tosPol = policies['terms-of-service'];
  const privacyPol = policies.privacy;

  return (
    <footer
      className="mt-auto border-t border-surface-border bg-surface-base px-24 py-20"
      style={style}
    >
      <div className="mx-auto flex max-w-[1200px] flex-col gap-16 md:flex-row md:items-center md:justify-between">
        <div className="flex items-center gap-12">
          <img
            src={config.logo}
            alt={config.productName}
            width={120}
            height="auto"
            className="brightness-0 invert"
          />
          <span className="text-12 text-on-surface-subtle">
            &copy; {new Date().getFullYear()} OnFrontiers, Inc.
          </span>
        </div>

        <nav className="flex flex-wrap items-center gap-16" aria-label="Footer">
          {!is404 && <FooterLink href={`${helpCenterUrl}/help-center`}>Help Center</FooterLink>}
          <FooterLink href={`${mainSiteUrl}/policies/privacy-policy`}>{privacyPol.name}</FooterLink>
          <FooterLink href={`${mainSiteUrl}/policies/terms-of-service`}>{tosPol.name}</FooterLink>
          {!is404 && <FooterLink href={`${mainSiteUrl}/blog`}>Blog</FooterLink>}
        </nav>
      </div>
    </footer>
  );
}
